module.exports = __webpack_public_path__ + "static/media/JS_CallApplyBind.919d370a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/images/JS_CallApplyBind.jpg
// module id = 105
// module chunks = 0